var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pop-panel-container"},[(this.name)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(this.name))]):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }